const newsDetailParams = {
    getUrlNewsDetail : "?populate=%2A",
    // getUrlNewsDetail : {
    //     populate : "populate=%2A",
    // }
}

export default newsDetailParams